(function (RR, $, jsData) {

  var m;

  RR.init = function() {

    RR.configureModel();
    App.updatePrice();
    RR.bindUIActions();
  }

  RR.showStep = function(step) {
    if(step == undefined)
      step = 1;

    $('.stage').hide();
    $('.stage' + step).fadeIn();
    $('.menu li.active').removeClass('active');
      $('.menu li:nth-child(' + step +')').addClass('active');
  }

  RR.updateSku = function(sku) {

    // Format according desired rules.
    App.m.selectedProduct.sku = sku;
    sku = App.m.selectedProduct.sku;
    if(sku.length > 0) {

      if(sku[sku.length - 1].toLowerCase() == 'p') {
          App.m.selectedProduct.sku = sku.substring(0, sku.length - 1)
      }

      App.m.selectedProduct.sku = App.m.selectedProduct.sku.toUpperCase();
    }

    console.log(App.m.selectedProduct.sku);
    
    // Try to set the image based on the skue.
    App.m.selectedProduct.image = 
      'https://fossil.scene7.com/is/image/FossilPartners/' + 
      App.m.selectedProduct.sku + '_main'; 
  }
  
  RR.bindUIActions = function () {

    if(App.m.selectedProduct.sku) {
      App.m.selectedProduct.image = 
          'https://fossil.scene7.com/is/image/FossilPartners/' + 
          App.m.selectedProduct.sku + '_main'; 
    }

    if(window.location.hash.indexOf('#step') >= 0) {
      RR.showStep(window.location.hash.replace('#step', ''));
    }

    window.onpopstate = function(e) {
      var step = (e.state != undefined) ? e.state.step : undefined;
      RR.showStep(step); 
    };

    $('#sku').on('change', function() {
      RR.updateSku($(this).val());
    });

    // Work around for hover IOS bug.
    $('.help-trigger').on('click', function(e) {
      $(this).next('.help-content').toggleClass('show').toggleClass('show');
    });

    $('#serial').on('change', function() {
      App.m.selectedProduct.serial = $(this).val().toUpperCase();
    });

    // Edit product information.
    $('.edit-product').on('click', function(e) {
      e.preventDefault();
      $('.popup').hide();
      $('#product-popup').show();
      $('#popup-sku').val(App.m.selectedProduct.sku);
      $('#popup-serial').val(App.m.selectedProduct.serial);
      window.Overlay.show();
    });

    // Save updates to the sku or serial.
    $('#product-popup button').on('click', function() {
  
      App.m.selectedProduct.serial = $('#popup-serial').val().toUpperCase();
      RR.updateSku($('#popup-sku').val());

      window.Overlay.hide();
    });
    
    $('.option').on('click', function() {

      if($(this).hasClass('disabled'))
        return;

      if($(this).hasClass('product-option')) {
        RR.showChoices('product');
      } else {
        RR.showChoices('brand');
      }
    });

    $('.close-choices').on('click', function() {
      RR.hideChoices();
    });
    
    $('.choice-list').on('click', '.choice', function() {
      	
        var $list = $(this).closest('.choice-list');
        
        var width = $list.find('.item').width();
        if($list.hasClass('product-choices')) {
            $option = $('.product-option');
          	App.m.selectedProduct.name = $(this).text();
            RR.setAvailableBrands();

            // Keep the selected brand only if it is available
            // for the new product type.
            var available = false;
            for(var i = 0; i < App.m.availableBrands.length; i++) {
              if(App.m.availableBrands[i] == App.m.selectedBrand)
                available = true;
            }

            if(!available) {
              App.m.selectedBrand = globalBrandLabel;
            }
        }
        else {
            $option = $('.brand-option');
            App.m.selectedBrand = $(this).text();
        }

        $('.brand-option').text(App.m.selectedBrand);
      
		    $option.css('width', width + 'px');
        $option.find('.item').text($(this).text());
        $option.css('width', $option.find('.item').width() + 'px');

        RR.hideChoices($option);

        App.setLogo(App.m.selectedBrand);
        
    });

    $('button.step1').on('click', function(e) {
      if($(this).hasClass('inactive'))
        return false;
        
        if(App.m.selectedProduct.name == jsData.skipWarrantyType &&
          (App.country == 'uk' || App.country == 'fr' || App.country == 'de')) {

          App.m.inWarranty = false;

          $('.find-brand').hide();
          $('.choose-repairs').fadeIn();
          $('.menu li.active').removeClass('active');
          $('.menu li.repairs').addClass('active');
          history.pushState({step: 3}, "", '#step3');
          
          RR.serialize();
        }
        else {
          $('.find-brand').hide();
          $('.select-warranty').fadeIn();
          $('.menu li.active').removeClass('active');
          $('.menu li.warranty').addClass('active');
          history.pushState({step: 2}, "", '#step2');

          RR.resetServices();
          
          RR.serialize();

          ga('set', 'page', 'WarrantySelector');
          ga('send', 'pageview');
        }

        window.scrollTo(0,0);
      });
      
      $('button.step2').on('click', function(e) {
        if($(this).hasClass('inactive'))
          return false;
        
        $('.select-warranty').hide();
        $('.choose-repairs').fadeIn();
        $('.menu li.active').removeClass('active');
        $('.menu li.repairs').addClass('active');
        history.pushState({step: 3}, "", '#step3');
        
        RR.serialize();
        window.scrollTo(0,0);

        ga('set', 'page', 'ServiceSelection');
        ga('send', 'pageview');
      });

      $('button.step3').on('click', function(e) {
        if($(this).hasClass('inactive'))
          return false;
        
        RR.serialize();
        RR.goCheckout();
      });

      $('.select-warranty .selection').on('click', function() {
          $('.selection').removeClass('selected');
          $(this).addClass('selected');
          App.m.inWarranty = $(this).hasClass('warranty');
          RR.mselectedProduct = [];
      });
      
      $('.choose-repairs').on('click', '.selection', function() {
      $(this).toggleClass('selected');
          if($(this).hasClass('selected'))
            RR.addService($(this).attr('service'));
          else
            RR.removeService($(this).attr('service'));
      });

      $('.choose-repairs').on('click', '.view-diagram', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var diagram = $(this).attr('diagram');
          if(diagram && diagram.indexOf('no-image') < 0) {
            $('#product-diagram').attr('src', diagram);
            $('#product-diagram').show();
            $('#default-diagram').hide();
          }
          else {
            $('#product-diagram').hide();
            $('#default-diagram').show();
          }
          $('.diagram').fadeIn();
      });

      $('.close-diagram').on('click', function() {
          $('.diagram').fadeOut();
      });
      
      $('.menu li.brand').on('click', function() {
        $('.service-page').hide();
        $('.find-brand').fadeIn();
        $('.menu li.active').removeClass('active');
        $('.menu li.brand').addClass('active');
        
        history.pushState({step: 1}, "", '#step1');
      });
      
      $('.menu li.warranty').on('click', function() {
        
        if(!App.m.selectedProduct.name || 
           App.m.selectedProduct.name == globalProductLabel || 
           !App.m.selectedBrand || 
           App.m.selectedBrand == globalBrandLabel) {
        
          return;
        }
         
        if(App.m.selectedProduct.name == jsData.skipWarrantyType &&
          (App.country == 'uk' || App.country == 'fr' || App.country == 'de')) {

          App.m.inWarranty = false;
          $('.repairs').trigger('click');
        }
        else {
          $('.find-brand').hide();
          $('.service-page').hide();
          $('.select-warranty').fadeIn();
          $('.menu li.active').removeClass('active');
          $('.menu li.warranty').addClass('active');
          history.pushState({step: 2}, "", '#step2');

          RR.resetServices();
          
          RR.serialize();
        }
      });
      
      $('.menu li.repairs').on('click', function() {

        if(!App.m.selectedProduct.name || 
          App.m.selectedProduct.name == globalProductLabel || 
          !App.m.selectedBrand || 
          App.m.selectedBrand == globalBrandLabel) {
       
         return;
       }
        
        if(App.m.inWarranty === '')
          return;

        RR.resetServices();
        
        $('.service-page').hide();
        $('.choose-repairs').fadeIn();
        $('.menu li.active').removeClass('active');
        $('.menu li.repairs').addClass('active');
        
        history.pushState({step: 2}, "", '#step3')
      });

      $('.choose-repairs').on('click', '#agent-damage', function() {
        App.updatePrice();
      });

      $('.choose-repairs').on('click', '#agent-fred', function() {
        App.updatePrice();
      });
  }
    

  // Perform processing necessary to setup checkout.
  RR.goCheckout = function() {

    // Remove any existing items in the cart and add the current
    // service selections.
    $.post('/cart/clear.js', function() {  
    
      // For each selected service/product find the correct variant
      // to add to the cart based on warranty status.
      var variants = [];
      for(i = 0; i < App.m.selectedServices.length; i++) {

        var service = App.m.selectedServices[i];

        // Default to the first variant and see if any other variants match
        // warranty or estimate conditions. We aren't guaranteed to find a 
        // match so additional processing needs to happen outside the loop.
        var variantToAdd = service.variants[0];
        for(var j=0; j < service.variants.length; j++) {
          var variant = service.variants[j];
          if((App.m.inWarranty && variant.type == App.warrantyVariant) || (!App.m.inWarranty && variant.type == App.nonWarrantyVariant) || variant.type == 'estimate') {
            variantToAdd = variant;
            break;
          }
        }

        var estimate = service.onquote ? 'quote' : service.price;
        if((App.m.inWarranty && service.warranty) || App.m.agent.fred || App.m.agent.damage) {
          estimate = 0;
        }

        var params = {
          id: variantToAdd.id,
          quantity: 1,
          properties: {
            'Estimate': estimate
          }
        };
        

        variants.push(params);
      }

      RR.addVariants(variants, 0);
      
    }, 'json');
  }

  
  // Add variants to the cart one at a time. Setup to process as recursive
  // calls since we need to know when the last is finished so we can 
  // add attributes and redirect to checkout.
  RR.addVariants = function(variants, index) {

    if(index >= variants.length) {

      // Store calculated taxes based on state.
      var taxList = '';
      var taxRates = Cookies.get('fossiltaxes');
      console.log(taxRates);
      if(taxRates != undefined) {
        taxRates = JSON.parse(taxRates);
        for(i = 0; i < taxRates.length; i++) {
          if(taxList.length > 0)
            taxList += ',';

          var value = ((App.m.prices.total) * parseFloat(taxRates[i].value) / 100).toFixed(2);
          taxList += taxRates[i].state + ':' + value;
        }
      }

      var language = chosenLanguage;
      if(App.country == 'fr')
        language = 'French';
      else if(App.country == 'de')
        language = 'German';

      var params = { 
        "attributes[SKU]": App.m.selectedProduct.sku,
        "attributes[Serial]": App.m.selectedProduct.serial,
        "attributes[Warranty]": App.m.hasNonWarranty ? 'Out of Warranty' : 'In Warranty',
        "attributes[EstimatedShipping]" : App.m.prices.shipping,
        "attributes[EstimatedLabor]" : App.m.prices.labor,
        "attributes[EstimatedTaxes]" : taxList,
        "attributes[EstimatedTotal]" : App.m.prices.total,
        "attributes[Store]": App.store,
        "attributes[CustomerNote]": App.m.note,
        "attributes[AgentName]": App.m.agent.name,
        "attributes[AgentNote]": App.m.agent.note,
        "attributes[StoreDamage]": App.m.agent.damage ? 'Yes' : 'No',
        "attributes[FredFossil]": App.m.agent.fred ? 'Yes' : 'No',
        "attributes[Brand]": App.m.selectedBrand,
        "attributes[ProductCategory]": App.m.selectedProduct.name,
        "attributes[Lang]": language,
        "attributes[InHouse]": (App.inhouse) ? true : false,
        "attributes[RequestData]": JSON.stringify(RR.serialize()),
        note: App.m.note
      };

      // We're done, add attributes and redirect to checkout.
      $.post('/cart/update.js', params, function() {
        window.location = '/checkout';
      }, 'json');
    }
    
    // More variants to go, add the next one.
    $.post('/cart/add.js', variants[index], function() {
      RR.addVariants(variants, index+1);
    }, 'json');
  }


  // Show the list of either product or brand choices.
  RR.showChoices = function(type) {
    $('.choice-list').hide();
  
    var $option = $('.' + type + '-option');
    var $choices = $('.' + type + '-choices');
    var top = $option.offset().top;
    var left = $option.offset().left;

    Scroll.lock()
    $('button').hide();
    $option.css('opacity', 0);
    $choices.css('top', top + 'px');
    $choices.css('left', left + 'px');
    $choices.show();
    $('.choices').show();
  }


  // Hide the list of product or brand choices.
  RR.hideChoices = function($option) {
      $('button').show();
      $('.choices').hide();
      $('.option').css('opacity', 1);
      Scroll.unlock();
  }


  // Make sure only brands that are available for the selected
  // product are available.
  RR.setAvailableBrands = function() {
    
    var availableBrands = [];
    for(var i=0; i<App.m.services.length; i++) {
      if(App.m.services[i].type == App.m.selectedProduct.name) {
        availableBrands.push(App.m.services[i].brand);
      }
    }

    availableBrands.sort();
    App.m.availableBrands = availableBrands.unique();
  }


  // Add a service to the collection of chosen services.
  RR.addService = function(service) {

    var newService;
    for(i = 0; i < App.m.services.length; i++) {
      if(App.m.services[i].handle == service)
        newService = App.m.services[i];
    }

    if(newService != undefined) {

      // Remove any existing services that should be exclusive to
      // the new service.
      for(i = 0; i < newService.tags.length; i++) {
        var tag = newService.tags[i];
        if(tag.indexOf('xor') != 0)
          continue;
          
        for(var j = 0; j < App.m.selectedServices.length; j++) {
          for(var k = 0; k < App.m.selectedServices[j].tags.length; k++) {
            if(tag == App.m.selectedServices[j].tags[k]) {

              // Uncheck the service in the UI.
              $('div[service="' + App.m.selectedServices[j].handle + '"]').removeClass('selected');
              
              // Remove the service from the selected services list.
              RR.removeService(App.m.selectedServices[j].handle);

              // Since we might be updating the selected services we need
              // to check the length again.
              if(j >= App.m.selectedServices.length)
                break;
            }
          }
        }
      }

      // Now add the new service.
      App.m.selectedServices.push(newService);
    }
    
    App.updatePrice();
    RR.serialize();
  }


  // Remove the service from the collection of chosen services.
  RR.removeService = function(service) {

    for(i = 0; i < App.m.selectedServices.length; i++) {
      if(App.m.selectedServices[i].handle == service) {
		    App.m.selectedServices.splice(i, 1);
        break;
      }
    }
    
    App.updatePrice();
    RR.serialize();
  }


  // Make sure only selected services are included
  // in the chosen services collection. An extra precaution
  // against stale data.
  RR.resetServices = function() {
    App.m.selectedServices = [];
    
    $('.choose-repairs .selection.selected').each(function() {
      RR.addService($(this).attr('service'));
    });
  }

  // Save the request data to storage so we can track
  // across page loads.
  RR.serialize = function() {
    return App.serialize();
  }

  // Once raw data is loaded, this will configure the data.
  RR.configureModel = function() {

    // Set which services should be selected.
    App.m.services = serviceData;
    for(var i=0; i < App.m.services.length; i++) {
      for(var j=0; j < App.m.selectedServices.length; j++) {
        if(App.m.services[i].id == App.m.selectedServices[j].id) {
          App.m.services[i].selected = true; 
        }
      }
    }

    // Configure products.
    App.m.products = productData.unique();
    App.m.products.sort();

    if(!App.m.selectedProduct.name) {
      App.m.selectedProduct.name = defaultProductName; 
      $('.product-choices .choice').first().trigger('click');
    }

    // Configure brands.
    App.m.brands = brandData.unique();
    App.m.brands.sort();
    RR.setAvailableBrands();
    
    if(!App.m.selectedBrand) {
      App.m.selectedBrand = defaultBrandName;
      $('.brand-choices .choice').first().trigger('click');
    }
  } 

}(window.RepairRequest = window.RepairRequest || {}, jQuery, jsData));
